'use client';

import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/* Render children as a direct child of <body>, escaping any local
   stacking context or containing block (e.g. a parent with `transform`
   or `will-change: transform`) that would otherwise trap the overlay.
   Every modal/sheet/full-screen-overlay on the site should be wrapped
   in <ModalPortal> so the overlay reliably covers the header, footer,
   and every other element in the layout. */
export default function ModalPortal({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
